import React from 'react';

function ListIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="15"
            enableBackground="new 0 0 512 512"
            viewBox="0 0 24 24"
        >
            <path
                xmlns="http://www.w3.org/2000/svg"
                d="M3.5 7h-2C.673 7 0 6.327 0 5.5v-2C0 2.673.673 2 1.5 2h2C4.327 2 5 2.673 5 3.5v2C5 6.327 4.327 7 3.5 7zm-2-4c-.275 0-.5.225-.5.5v2c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5zM3.5 15h-2C.673 15 0 14.327 0 13.5v-2c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v2c0 .827-.673 1.5-1.5 1.5zm-2-4c-.275 0-.5.225-.5.5v2c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5zM3.5 23h-2C.673 23 0 22.327 0 21.5v-2c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v2c0 .827-.673 1.5-1.5 1.5zm-2-4c-.275 0-.5.225-.5.5v2c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5zM23.5 5h-16a.5.5 0 010-1h16a.5.5 0 010 1zM23.5 13h-16a.5.5 0 010-1h16a.5.5 0 010 1zM23.5 21h-16a.5.5 0 010-1h16a.5.5 0 010 1z"
                data-original="#000000"
            />
        </svg>
    );
}

export { ListIcon };
